import { createSlotRecipe } from './runtime';

const toastConfig = {"name":"toast","slots":["region","root","content","body","icon","title","description","closeButton"],"defaultVariants":{"status":"info"},"variantMap":{"status":["info","success","warning","error"]}}

export const toast = /* @__PURE__ */ createSlotRecipe(toastConfig)